
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetCepingList,
  GetCepingTypeList,
  EditCepingPinggu,
  EditCeping,
} from "@/request/content";
import Transfer from "@/components/transfer/transfer.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
    Transfer,
  },
})
export default class Name extends mixins(listMixin) {
  private IfShowTransfer: any = false;
  private data: any[] = [];
  private typeData: any = [];
  private defaultProps: any = {
    children: "children",
    label: "id",
  };
  private types: any = [];
  private ifShowSelectType: any = false;
  private ifShowAddSelect: any = false;
  private ifShowAddType: any = false;
  private selectData: any = {
    类别: {},
  };
  private H: any = "";
  private forceUpdate() {
    this.$forceUpdate();
  }
  // 记录类别的索引，方便删除
  private createIndex() {
    this.typeData.forEach((ele: any, i: any) => {
      ele.index = i;
    });
  }
  private openTransfer() {
    this.IfShowTransfer = true;
  }
  private goRead(item: any) {
    this.$router.push({
      path: "/main/ceping/read",
      query: {
        id: item.template_id,
      },
    });
  }
  private addOne() {
    this.typeData.push({ id: "" });
    this.createIndex();
  }
  private delOne(data: any) {
    this.$confirm("确定删除该类别么？", "删除", {
      customClass: "commonConfirm",
    })
      .then(() => {
        this.typeData.splice(data.index, 1);
        this.createIndex();
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private switchChange(item: any) {
    console.log(item);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      template_id: item.template_id,
      启用手机端: item["启用手机端"],
    };
    EditCeping(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.getList();
      })
      .catch(() => {
        loading.close();
        this.getList();
      });
  }
  private openSelect(item: any) {
    this.selectData = JSON.parse(JSON.stringify(item));
    this.selectData["评估类型"] = this.selectData["类别"];
    this.ifShowSelectType = true;
  }
  private openAddSelect() {
    this.getTypeData();
    this.ifShowAddSelect = true;
  }
  private getTypeData() {
    GetCepingTypeList(this).then((res: any) => {
      this.typeData = [];
      this.types = res;
      res.forEach((ele: any) => {
        this.typeData.push({ id: ele });
      });
      this.createIndex();
    });
  }
  private addSelectSure() {
    let arr: any = [];
    // 过滤空值以及重复值
    this.typeData.forEach((ele: any) => {
      if (ele.id) {
        const index = arr.findIndex((d: any) => d.id === ele.id);
        if (index == -1) {
          arr.push(ele.id);
        }
      }
    });
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditCepingPinggu(this, arr, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("修改成功");
        this.ifShowAddSelect = false;
        this.getList();
        this.getTypeData();
      })
      .catch(() => {
        loading.close();
      });
  }
  private selectSure() {
    // if (!this.selectData["评估类型"]) {
    //   this.$message.warning("请选择评估类型");
    //   return;
    // }
    // if (!this.selectData["报告类型"]) {
    //   this.$message.warning("请选择报告类型");
    //   return;
    // }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      template_id: this.selectData.template_id,
      类别: this.selectData["评估类型"],
      报告类型: this.selectData["报告类型"],
    };
    EditCeping(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.ifShowSelectType = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private jinyong(item: any) {
    this.$confirm("确定要禁用该测评么？", "禁用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        template_id: item.template_id,
        状态: "禁用",
      };
      EditCeping(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.ifShowSelectType = false;
          this.$message.success("禁用成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private qiyong(item: any) {
    this.$confirm("确定要启用该测评么？", "启用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        template_id: item.template_id,
        状态: "正常",
      };
      EditCeping(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.ifShowSelectType = false;
          this.$message.success("启用成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private goAdd() {
    this.$router.push({
      path: "/main/content/kepuku-compose-kepu",
    });
  }

  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        类别: this.filters["类别"],
        状态: this.filters["状态"],
        search: this.filters.search,
        current_page: this.filters.current_page,
        page_count: this.filters.page_count,
        order_key: "",
      },
    };
    localStorage.setItem("cepingFilter", JSON.stringify(this.filters));
    GetCepingList(this, params)
      .then((res: any) => {
        loading.close();
        this.data = res.datas;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "更新时间";
    this.filters.sort_value = 1;
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("cepingFilter")) {
      this.filters = JSON.parse(localStorage.getItem("cepingFilter") as any);
    }
    this.getList();
    this.getTypeData();
  }
}
